module.exports = __webpack_public_path__ + "img/1F1E7-1F1E7.e1a5d06a.svg";